import React from 'react';

const LabOrderDetail = (props) => {
    const {id, customer_description,force_return,use_insurance,final_price} = props.order;
    const getPrescriptionReason = () => {
        if (!force_return){
            return "-";
        }
        if (use_insurance){
            return "نسخه شامل بیمه است.";
        }else{
            return "نسخه شامل داروی خاص است.";
        }
    }

    return(
        <div className="lab-order-const-detail">
            <div className="item-holder">
                <span className="item-title">
                    کد سفارش :
                </span>
                <span className="item-value">
                    {id ?? "-"}
                </span>
            </div>
            <div className="item-holder">
                <span className="item-title">
                    نیاز به ارسال نسخه :
                </span>
                <span className="item-value">
                    {force_return ? 'دارد' : "ندارد"}
                </span>
            </div>
            <div className="item-holder">
                <span className="item-title">
                    دلیل ارسال نسخه :
                </span>
                <span className="item-value">
                    {getPrescriptionReason()}
                </span>
            </div>
            <div className="item-holder">
                <span className="item-title">
                    توضیحات :
                </span>
                <span className="item-value">
                    {customer_description ?? '-'}
                </span>
            </div>
        </div>
    )
};

export default LabOrderDetail;